import { createReducer, success } from 'redux/shelf';
import { actions as integration } from 'modules/integration';
import session from 'lib/session';
import { saga } from './sagas';
import actions from './actions';

const initialState = {
  merchantId: session.merchant,
  onboardingId: void 0,
  isCCExpired: false,
};

export const Platforms = {
  shopify: {
    name: 'shopify',
    title: 'Shopify',
  },
  bigcommerce: {
    name: 'bigcommerce',
    title: 'BigCommerce',
  },
  magento: {
    name: 'magento',
    title: 'Magento',
  },
  generic: {
    name: 'generic',
    title: 'Generic',
  },
  magento2: {
    name: 'magento2',
    title: 'Magento 2',
  },
  maropost: {
    name: 'maropost',
    title: 'Maropost',
  },
  jetshop: {
    name: 'jetshop',
    title: 'Jetshop',
  },
};

export type MerchantPlatform = keyof typeof Platforms;

export const getPlatformTitle = (platform: MerchantPlatform) =>
  Platforms[platform] ? Platforms[platform].title : Platforms.generic.title;

export const reducer = createReducer(
  [actions.getUser, actions.getMerchant],
  {
    [actions.signOut]: (s) => ({ ...s, merchantId: void 0 }),
    [actions.setMerchantId]: (s, { payload }) => ({
      ...s,
      merchantId: payload,
    }),
    [actions.setOnboardingId]: (s, { payload }) => ({
      ...s,
      onboardingId: payload,
    }),
    [success(actions.validateCC)]: (s, { payload }) => ({ ...s, ...payload }),
    [success(integration.startSearch)]: (s) => ({
      ...s,
      merchant: { ...s.merchant, status: 'live' },
    }),
    [success(integration.pauseSearch)]: (s) => ({
      ...s,
      merchant: { ...s.merchant, status: 'paused' },
    }),
    [success(actions.getShopifyThemes)]: (s, { payload }) => ({
      ...s,
      shopifyThemes: [...payload.themes],
    }),
    [success(actions.checkShopifyOnlineStore2Support)]: (s, { payload }) => ({
      ...s,
      hasOnlineStore2Support: payload.hasOnlineStore2Support,
    }),
  },
  initialState
);

export { saga, actions };
